import React, { Component } from 'react';
import * as ct from '../../shared/ClientConstants';

export class StatusId extends Component {
  render() {
    switch (this.props.status) {
      case ct.TOURNAMENT_STATUS_CREATED:
        return (
          <label {...this.props} className='badge badge-info'>
            CREATED
          </label>
        );
      case ct.TOURNAMENT_STATUS_REGISTRATION_OPEN:
        return (
          <label {...this.props} className='badge badge-primary'>
            REG OPEN
          </label>
        );
      case ct.TOURNAMENT_STATUS_REGISTRATION_CLOSED:
        return (
          <label {...this.props} className='badge badge-info'>
            REG CLOSED
          </label>
        );
      case ct.TOURNAMENT_STATUS_READY:
        return (
          <label {...this.props} className='badge badge-warning'>
            READY
          </label>
        );
      case ct.TOURNAMENT_STATUS_IN_PROGRESS:
        return (
          <label {...this.props} className='badge badge-warning'>
            IN PROGRESS
          </label>
        );
      default:
        return (
          <label {...this.props} className='badge badge-success'>
            COMPLETED
          </label>
        );
    }
  }
}

export default StatusId;
